// frontend/admin-portal/src/services/settingsService.js
import api from './axiosConfig';

export const settingsService = {
    list: async (group) => {
        const params = group ? { group } : {};
        const { data } = await api.get('/settings', { params });
        return data.data.settings;
    },
    listPublic: async () => {
        const { data } = await api.get('/settings/public');
        return data.data.settings;
    },
    get: async (key) => {
        const { data } = await api.get(`/settings/${key}`);
        return data.data.setting;
    },
    update: async (key, value) => {
        const { data } = await api.put(`/settings/${key}`, { value });
        return data.data;
    },
    updateMany: async (settings) => {
        const { data } = await api.put('/settings', { settings });
        return data.data.results;
    },
    upsert: async (key, payload) => {
        const { data } = await api.post(`/settings/${key}`, payload);
        return data.data.setting;
    },
    changeAnchor: async (anchor, baseCurrency) => {
        const { data } = await api.put('/settings/finance/anchor', { anchor, baseCurrency });
        return data.data;
    },
};